import {CustomText, PSmallText} from '@buncha/components/core/text';
import {
  DeliveryLocationStatus,
  OrderItemStatus,
} from '@buncha/batchDetails/types';
import React, {Fragment, useCallback, useState} from 'react';
import {useColorThemeType, useFontTheme} from '@buncha/appStyles/hooks/theme';

import AppModal from '@buncha/common/components/CustomModal/AppModal';
import {Box} from '@buncha/components/core/view';
import If from '@buncha/components/conditional/If';
import {Modules} from '@buncha/utils/types';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {Sensitivity} from '@buncha/itemDetails/types/ItemScanner';
import {SpinnerComponent} from '@buncha/components/core/loader';
import {StyleSheet} from 'react-native';
import {Touchable} from '@buncha/components/core/touchable';
import {useGetLocale} from '@buncha/localization/hooks';
import {useRoute} from '@react-navigation/native';
import {useUpdateOrderItemStatus} from '@buncha/batchDetails/hooks/BatchDetails';

interface DropItemProps {
  undrop: boolean;
  orderStatus?: DeliveryLocationStatus;
  orderItemId: number;
  handleDrop: (val: boolean) => void;
  mode?: Sensitivity;
}

const DropItem = (props: DropItemProps) => {
  const theme = useColorThemeType('main');
  const muliFont = useFontTheme();
  const {undrop, orderItemId, orderStatus} = props;
  const {title, body, button} =
    useGetLocale(Modules.itemDetails, ShopperScreens.ItemDetails) ?? {};

  const [dropModal, setDropModal] = useState(false);

  const routeParams: any = useRoute()?.params;

  const runId = routeParams?.runId;

  const {updateOrderItemStatus, changeStatusState} = useUpdateOrderItemStatus();

  const handleItemStatus = useCallback(
    (update?: boolean) => {
      let status = OrderItemStatus.dropped;
      if (!undrop && !update) return setDropModal(true);
      if (undrop)
        status =
          orderStatus === DeliveryLocationStatus.readyToPack
            ? OrderItemStatus.notPacked
            : OrderItemStatus.notPicked;
      updateOrderItemStatus(runId, status, [orderItemId], () =>
        props.handleDrop(!undrop),
      );
    },
    [orderItemId, orderStatus, props, runId, undrop, updateOrderItemStatus],
  );

  const dropItem = useCallback(() => {
    setDropModal(false);
    handleItemStatus(true);
  }, [handleItemStatus]);

  return (
    <Fragment>
      <AppModal
        isOpen={dropModal}
        onClose={() => setDropModal(false)}
        topCTAHandelr={dropItem}
        bottomCTAHandelr={() => setDropModal(false)}
        title={title?.dropThisItem}
        subTitle={body?.dropItem}
        ctaBottomTitle={button?.no}
        ctaTopTitle={button?.yes}
        topCTAColor={theme?.background.red[100]}
      />
      <Touchable style={[styles.Container]} onPress={() => handleItemStatus()}>
        <If condition={changeStatusState.loading}>
          <SpinnerComponent size="sm" />
        </If>
        <If condition={!changeStatusState.loading}>
          <Box style={[styles.jcc]}>
            <If condition={props.mode === Sensitivity.weightSensitive}>
              <CustomText
                style={[
                  styles.nameTypo,
                  {
                    color: theme?.text.red[100],
                    fontFamily: muliFont[600].normal,
                  },
                ]}>
                {undrop ? body?.drop?.[1] : body?.drop?.[0]}
                {body?.drop?.[2]}
              </CustomText>
            </If>
            <If condition={props.mode !== Sensitivity.weightSensitive}>
              <PSmallText
                style={[
                  styles.nameTypo,
                  {
                    color: theme?.text.red[100],
                    fontFamily: muliFont[600].normal,
                  },
                ]}>
                {undrop ? body?.drop?.[1] : body?.drop?.[0]}
                {body?.drop?.[2]}
              </PSmallText>
            </If>
          </Box>
        </If>
      </Touchable>
    </Fragment>
  );
};

const styles = StyleSheet.create({
  Container: {
    flexDirection: 'row',
  },
  nameTypo: {
    textAlign: 'left',
  },
  jcc: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
});

export default React.memo(DropItem);
